const pages = {
  // Properties page
  'props.sectionLabel': 'Homes for sale',
  'props.title': 'Browse homes for sale',
  'props.intro': 'Browse our current inventory of Japanese homes. New listings are added weekly.',
  'props.noResults': 'No properties match your filters.',
  'props.propertyNotFound': 'Property not found.',

  // Property detail
  'detail.breadcrumbHomes': 'Homes',
  'detail.opportunity': 'The opportunity',
  'detail.specifications': 'Specifications',
  'detail.renovationPlan': 'Renovation plan',
  'detail.indicativeReturn': 'Indicative all-in & return',
  'detail.area': 'Area',
  'detail.mapPlaceholder': 'Map shown after inquiry',
  'detail.buyTogether': 'Buy it together',
  'detail.buyTogetherDesc': 'Co-ownership matching lets a small group purchase this property in their own names on title. Each owner holds a registered share (持分). NOREN introduces potential co-owners and brokers the transaction. Owners set all terms in their own written agreement with their own legal counsel.',
  'detail.offMarketNotice': 'Good to know:',
  'detail.offMarketNoticeText': 'Prices, measurements, and availability are confirmed during inquiry. Get in touch for full details, viewings, and an all-in renovation estimate.',
  'detail.cgCaption': 'The first {{cgCount}} image{{cgCountPlural}} {{cgCountVerb}} renovation visualizations (CG). The final {{currentCount}} show the property in its current condition.',
  'detail.unknownSpec': '— enter {{field}}',
  'detail.disclaimer': 'All projections are illustrative and based on conservative modelling. Actual costs and yields depend on renovation scope, market conditions, and regulatory compliance. Each property is individually modelled before purchase.',

  // Co-ownership page
  'co.pageLabel': 'Co-ownership matching',
  'co.pageTitle': 'Buy together.',
  'co.pageTitleItalic': 'Own on title. Share on your terms.',
  'co.pageIntro': 'NOREN introduces verified co-owners for properties that suit shared purchase. Each owner buys their share directly on title in their own name. NOREN does not pool money, run investments, or guarantee returns.',
  'co.legalBannerTitle': 'How this works:',
  'co.legalBannerText': 'NOREN is a matching board and licensed property agent only. We introduce potential co-owners and broker property transactions. We do NOT pool or hold money, do NOT operate properties as investments, and do NOT distribute returns. Co-owners buy in their own names on title (持分), set all terms in their own written agreement with their own lawyers and tax advisors, and bear all risk and disputes. Every co-owner must obtain independent legal and tax advice before proceeding.',
  'co.filterAll': 'All',
  'co.filterOpen': 'Spots open',
  'co.filterAlmost': 'Almost full',
  'co.filterKominka': 'Kominka',
  'co.noCampaigns': 'No campaigns match this filter.',
  'co.buyingInto': 'What you\'d be buying into',
  'co.proposedSplit': 'Proposed split',
  'co.stepsTitle': 'Match → Agreement → Purchase → Registration → Operation',
  'co.risksTitle': 'Risks & disclosures',
  'co.sidebarShare': 'Approx. per share',
  'co.sidebarAllIn': '{{allIn}} ÷ {{count}} owners',
  'co.sidebarFilled': '{{filled}} of {{wanted}} spots filled',
  'co.step1': '01',
  'co.step1Title': 'Match',
  'co.step1Desc': 'NOREN introduces verified co-owners who have passed budget and intent screening. No pooled money is held by NOREN.',
  'co.step2': '02',
  'co.step2Title': 'Agreement',
  'co.step2Desc': 'Co-owners draft and sign a written co-ownership agreement with their own lawyers and tax advisors. Terms are private between owners.',
  'co.step3': '03',
  'co.step3Title': 'Purchase',
  'co.step3Desc': 'Each co-owner buys their share (持分) directly on title in their own name. NOREN brokers the transaction as a licensed agent.',
  'co.step4': '04',
  'co.step4Title': 'Registration',
  'co.step4Desc': 'Title is registered at the Legal Affairs Bureau with each owner\'s share recorded. NOREN assists with documentation.',
  'co.step5': '05',
  'co.step5Title': 'Optional operation',
  'co.step5Desc': 'Co-owners may engage NOREN or a third party to manage renovation, furnishing, and rental operations. All income and costs flow directly to owners.',
  'co.guardrailSidebar': 'Guardrail:',
  'co.guardrailSidebarText': 'NOREN does not pool money, operate properties, or guarantee returns. Co-owners bear all risk and must obtain independent legal and tax advice.',

  // Contact page
  'contact.sectionLabel': 'Get in Touch',
  'contact.title': 'Get in touch',
  'contact.intro': 'Tell us your budget, goals, and timeline. We will send you a curated shortlist of homes for sale.',
  'contact.firstName': 'First name',
  'contact.lastName': 'Last name',
  'contact.email': 'Email',
  'contact.country': 'Country',
  'contact.budget': 'Budget range (JPY)',
  'contact.goal': 'What are you looking for?',
  'contact.message': 'Message (optional)',
  'contact.messagePlaceholder': 'Tell us about your timeline, preferred regions, or any questions...',
  'contact.privacy': 'We never share your details. Typical response time: under 48 hours.',

  // About page
  'about.storyLabel': 'Our Story',
  'about.storyTitle': 'We exist because we were you.',
  'about.storyP1': 'NOREN was founded by a team of foreign buyers who tried to purchase rural Japanese property on their own. We lost money on bad inspections, misread contracts, hired the wrong contractors, and discovered the minpaku licence rules the hard way.',
  'about.storyP2': 'We built NOREN to be the service we wished existed: a bilingual, end-to-end partner that handles sourcing, purchase, renovation, licensing, and management — without requiring you to fly to Japan or learn Japanese.',
  'about.storyP3': 'We are licensed real estate brokers, but we do not behave like traditional agents. We talk buyers out of bad deals. We share actual occupancy data, not cherry-picked examples. We charge transparent margins and show you every invoice.',
  'about.locationLabel': 'Nagano City, Japan',
  'about.valuesLabel': 'What We Believe',
  'about.value1Title': 'Radical honesty',
  'about.value1Body': 'We tell you when a property is a bad investment. We share real occupancy data, actual maintenance costs, and conservative yield projections. We would rather lose a sale than mislead a client.',
  'about.value2Title': 'End-to-end ownership',
  'about.value2Body': 'We do not drop you after purchase. We manage the renovation, file the licences, list the property, handle guests, and send you monthly P&L reports in English. You own the asset. We run the operation.',
  'about.value3Title': 'No flying required',
  'about.value3Body': 'Every document is translated. Every call has an interpreter. Every inspection is filmed with English commentary. You can own and operate a Japanese property without ever setting foot in Japan.',
  'about.statsProps': 'Properties managed',
  'about.statsPrefs': 'Prefectures active',
  'about.statsSupport': 'English support',
  'about.statsFees': 'Hidden fees',
  'about.teamLabel': 'The Team',
  'about.teamTitle': 'Small team, deep expertise',
  'about.teamDesc': 'Our core team is based in Nagano, with partners in Tokyo, Yokohama, and Saitama. We are licensed real estate brokers, renovation project managers, and licensed minpaku operators. Every property we source has been physically inspected by a team member.',
  'about.roleSourcing': 'Sourcing & Purchase',
  'about.roleSourcingDesc': 'Licensed brokers who negotiate deals and manage closing.',
  'about.roleReno': 'Renovation',
  'about.roleRenoDesc': 'In-house designers and vetted local contractors across six prefectures.',
  'about.roleOps': 'Operations',
  'about.roleOpsDesc': 'Guest communication, cleaning coordination, and monthly reporting.',
  'about.ctaTitle': 'Want to know more?',
  'about.ctaDesc': 'We are happy to share our track record, explain our fee structure, or walk you through a real case study.',

  // How it works page
  'hiw.sectionLabel': 'The Process',
  'hiw.title': 'Six steps from first conversation to a rented, operating property.',
  'hiw.intro': 'Every step is managed in English. You do not need to visit Japan. You do not need to speak Japanese. We handle the paperwork, the contractors, the licences, and the guest communication.',
  'hiw.timelineLabel': 'Typical Timeline',
  'hiw.phaseMatch': 'Match',
  'hiw.phaseMatchWeeks': 'Week 1–2',
  'hiw.phaseMatchDesc': 'Shortlist curation',
  'hiw.phaseInspect': 'Inspect',
  'hiw.phaseInspectWeeks': 'Week 2–3',
  'hiw.phaseInspectDesc': 'Structural review',
  'hiw.phasePurchase': 'Purchase',
  'hiw.phasePurchaseWeeks': 'Week 4–8',
  'hiw.phasePurchaseDesc': 'Contract & close',
  'hiw.phaseRenovate': 'Renovate',
  'hiw.phaseRenovateWeeks': 'Week 9–24',
  'hiw.phaseRenovateDesc': '8–16 weeks typical',
  'hiw.phaseLaunch': 'Launch',
  'hiw.phaseLaunchWeeks': 'Week 25–28',
  'hiw.phaseLaunchDesc': 'Licence & listing',
  'hiw.phaseOperate': 'Operate',
  'hiw.phaseOperateWeeks': 'Ongoing',
  'hiw.phaseOperateDesc': 'Monthly reporting',
  'hiw.ctaTitle': 'Ready to see properties?',
  'hiw.ctaDesc': 'Tell us your budget and goals. We will send a curated shortlist within 48 hours.',

  // Regions page
  'regions.sectionLabel': 'Japan Region Guides',
  'regions.title': 'Where to buy',
  'regions.intro': 'Every region has a different risk profile, price band, and rental demand curve. We only source in areas where we have inspected, renovated, and operated properties ourselves.',
  'regions.activeArea': 'Active sourcing area',
  'regions.mapLabel': 'Coverage Map',
  'regions.mapDesc': 'Our current sourcing footprint covers Kanto and surrounding prefectures. We do not list properties in regions we have not personally inspected.',
  'regions.inventoryLabel': 'Current Inventory by Region',
  'regions.properties': 'properties',

  // Honesty page
  'honesty.sectionLabel': 'Radical Honesty',
  'honesty.title': 'What other agents will not tell you',
  'honesty.intro': 'We lose deals by being honest. We also keep clients for years because they trust us. Here is everything you need to know before you buy property in Japan as a foreign non-resident.',
  'honesty.moreTruths': 'More Hard Truths',
  'honesty.truth1Title': 'Renovation costs are higher than you think',
  'honesty.truth1Body': 'A ¥500,000 house often needs ¥3–5M in renovation. We give you a pre-purchase estimate so you know the total cost before you commit. No surprises.',
  'honesty.truth2Title': 'Rural properties rarely appreciate',
  'honesty.truth2Body': 'Japan\'s rural population is shrinking. Do not buy a cheap akiya expecting capital gains. Buy for yield, personal use, or portfolio diversification.',
  'honesty.truth3Title': 'Taxes are not optional',
  'honesty.truth3Body': 'Fixed asset tax, income tax on rental revenue, and consumption tax on short-term stays. We handle your annual tax filing in English. You still have to pay.',
  'honesty.truth4Title': 'Management is not passive',
  'honesty.truth4Body': 'Even with a property manager, you will review monthly reports, approve major repairs, and make strategic decisions. We make it as hands-off as possible. It is never fully passive.',
  'honesty.disclaimerLabel': 'Full Disclaimer',
  'honesty.disclaimerText': 'All projected yields, occupancy rates, and renovation estimates are illustrative and based on conservative modelling for representative properties. Actual returns depend on location, renovation scope, licensing path, and market conditions. Past performance of NOREN-managed properties does not guarantee future results. Each property is individually modelled before purchase. Ownership of Japanese real estate does not confer residency or visa rights. Foreign buyers must comply with FEFTA reporting and all applicable 2026 disclosure requirements. NOREN K.K. is a licensed real estate broker in Japan.',

  // Not found
  'notFound.title': 'Page not found',
  'notFound.desc': 'The page you are looking for does not exist.',
  'notFound.backHome': 'Back to home',
};

export default pages;